import { render, staticRenderFns } from "./SendComplianceFormsModal.vue?vue&type=template&id=44265f32&scoped=true"
import script from "./SendComplianceFormsModal.vue?vue&type=script&lang=js"
export * from "./SendComplianceFormsModal.vue?vue&type=script&lang=js"
import style0 from "./SendComplianceFormsModal.vue?vue&type=style&index=0&id=44265f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44265f32",
  null
  
)

export default component.exports